export default __webpack_public_path__ + "static/media/concertHalls.f07f7d9d.jpg";